//import ExcelJS from 'exceljs/dist/es5/exceljs.browser.js';
import * as ExcelJS from 'exceljs/dist/exceljs';
import { saveAs } from 'file-saver';

export default async function downLoadExcel(wb, fileName) {
    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf]), `${fileName}.xlsx`)
}